import { render } from "./SistemLayout.vue?vue&type=template&id=6371a99f"
import script from "./SistemLayout.vue?vue&type=script&lang=js"
export * from "./SistemLayout.vue?vue&type=script&lang=js"

import "./SistemLayout.vue?vue&type=style&index=0&id=6371a99f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__